module.exports = __webpack_public_path__ + "img/arrow_up_b.7ff315ba.svg";